<div class="editable-card">
  @if (header) {
    <div class="row row--align-center row--space-between editable-card__header">
      <div>
        @if (icon) {
          <div class="editable-card__icon" [ngStyle]="{'background': iconColor}">
            <i id="editable-card.icon" class="material-icons-outlined">
              {{iconName}}
            </i>
          </div>
        }
      <h2 class="editable-card__title" [ngStyle]="{
            'text-align': headerLeftAlign ? 'left' : 'center',
            'margin-left': headerLeftAlign ? '12px' : '',
            'font-weight': headerBoldFont ? 'bold' : 'normal'}">
          {{header}}
        </h2>
      </div>
      @if (showEditControls) {
        <div class="row--end">
          <button id="editable-card.editBtn" data-cy="editable-card-editBtn" type="button"
            class="btn btn--secondary-outline btn--xs" [ngClass]="{'disabled': !viewOnly}" [disabled]="!viewOnly"
            data-tool-tip="Edit Form" (click)="edit()">
            <i class="material-icons-outlined">{{editIconOverride ? editIconOverride : 'edit'}}</i>
            {{editTextOverride ? editTextOverride : 'Edit'}}
          </button>
          <button id="editable-card.undoBtn" data-cy="editable-card-undoBtn" type="button"
            class="btn btn--secondary-outline btn--xs" [ngClass]="{'disabled': viewOnly}" [disabled]="viewOnly"
            data-tool-tip="Discard Changes" (click)="discard()">
            <i class="material-icons-outlined">undo</i>
            Undo
          </button>
          <button id="editable-card.saveBtn" data-cy="editable-card-saveBtn" type="button"
            class="btn btn--secondary-outline btn--xs" [ngClass]="{'disabled': viewOnly || !formValid}"
            [disabled]="viewOnly || !formValid" data-tool-tip="Save Changes" (click)="save()">
            <i class="material-icons-outlined">save</i>
            Save
          </button>
        </div>
      }
    </div>
  }
  <div class="editable-card__body" [ngStyle]="{
    'margin-bottom': icon ? '33px' : '12px'}">
    <fieldset class="app-field-set" [disabled]="!ignoreWriteAccess && !writeAccess"
      [ngClass]="{'disabled': !ignoreWriteAccess && !writeAccess}">
      <ng-content></ng-content>
    </fieldset>
  </div>
</div>
